// A plain, framework-free re-entrancy guard for a form submission. Pulled
// out of disable_on_submit_controller.js so the locking decision itself —
// the part actually worth protecting against a regression — can be tested
// in plain Node, without a browser, Stimulus, or Capybara's inherent
// limits reproducing a genuine double-submit race (see
// test/javascript/submit_lock_test.mjs and the Stimulus controller for why
// a browser-driven system spec cannot reliably exercise this).
export function createSubmitLock() {
  let locked = false;

  return {
    // Returns true the first time it's called — the caller should let that
    // submission through, after running `onFirstLock` to disable the
    // controls. Every call after that returns false, telling the caller to
    // refuse the submission (e.g. via event.preventDefault()) without
    // running `onFirstLock` again.
    lock(onFirstLock) {
      if (locked) return false;

      locked = true;
      onFirstLock();
      return true;
    },
  };
}
